import { createSelector } from 'reselect';

const selectCascadedAccounts = (state: any) => state.cascadedAccounts;


export const selectCascadedAccountsCurrentItem = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.current);

export const selectCascadedAccountsListItems = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.list);

export const selectCascadedAccountsItemById = (itemId: any) =>
    createSelector(selectCascadedAccountsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCascadedAccountsCreatedItem = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.create);

export const selectCascadedAccountsUpdatedItem = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.update);

export const selectCascadedAccountsReadItem = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.read);

export const selectCascadedAccountsDeletedItem = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.delete);

export const selectCascadedAccountsSearchedItems = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.search);

export const selectCascadedAccountsItemsCount = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.count);

export const selectCascadedAccountsItemsFilter = createSelector([selectCascadedAccounts], (cascadedAccounts) => cascadedAccounts.filter);